import { render } from "./YachtVideo.vue?vue&type=template&id=8e3cdb50&scoped=true"
import script from "./YachtVideo.vue?vue&type=script&lang=js"
export * from "./YachtVideo.vue?vue&type=script&lang=js"

import "./YachtVideo.vue?vue&type=style&index=0&id=8e3cdb50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e3cdb50"]])

export default __exports__